<template>
    <modal @close="emit('close')">
        <div class="relative w-[332px]">
            <div class="ds-glass-dialog-title">{{ title }}</div>

            <div v-if="mode === 'confirm' && preview" class="mt-4 text-[13px] leading-[140%] text-darkgray">
                <div>Будет удалено: {{ formatShifts(preview.total_shifts_to_delete) }}.</div>
                <div>Будет создано: {{ formatShifts(preview.total_shifts_to_create) }}.</div>
                <div class="mt-3 max-h-56 overflow-y-auto">
                    <div v-if="copyableEmployments.length">
                        <div>Будут скопированы:</div>
                        <div v-for="employment in copyableEmployments" :key="employment.employment_id">
                            ✓ {{ employment.employee_name }}: {{ formatShifts(employment.shifts_to_create_count) }}
                        </div>
                    </div>
                    <div v-if="skippedEmployments.length" :class="{ 'mt-3': copyableEmployments.length }">
                        <div>Не будут скопированы:</div>
                        <div v-for="employment in skippedEmployments" :key="employment.employment_id">
                            ✗ {{ employment.employee_name }}: {{ employment.errors.map(error => error.message).join(', ') }}
                        </div>
                    </div>
                </div>
                <div class="mt-3">Продолжить?</div>
            </div>

            <div v-else class="mt-4 max-h-56 overflow-y-auto">
                <div v-for="(error, index) in errors" :key="`${error.code}-${index}`" class="text-[13px] leading-[140%] text-darkgray mb-2 last:mb-0">
                    {{ formatError(error) }}
                </div>
            </div>

            <div class="ds-glass-dialog-actions">
                <button type="button" class="ds-glass-btn ds-glass-btn-secondary" :disabled="isLoading" @click.prevent="emit('close')">
                    {{ mode === 'confirm' ? 'Отмена' : 'Закрыть' }}
                </button>
                <button v-if="mode === 'confirm'" type="button" class="ds-glass-btn ds-glass-btn-primary" :disabled="isLoading" @click.prevent="emit('confirm')">
                    Скопировать
                </button>
            </div>
        </div>
    </modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { CopyError, ShiftCopyPreviewResponse } from '@/api/schedule'

const props = defineProps<{
    mode: 'confirm' | 'errors'
    errors: CopyError[]
    preview: ShiftCopyPreviewResponse['preview']
    isLoading: boolean
}>()

const copyableEmployments = computed(() => props.preview?.employments.filter(item => item.can_copy) ?? [])
const skippedEmployments = computed(() => props.preview?.employments.filter(item => !item.can_copy) ?? [])

const emit = defineEmits<{
    close: []
    confirm: []
}>()

const title = 'Копирование смен'

function formatShifts(count: number) {
    const remainder100 = count % 100
    const remainder10 = count % 10
    const word = remainder100 >= 11 && remainder100 <= 14
        ? 'смен'
        : remainder10 === 1
            ? 'смена'
            : remainder10 >= 2 && remainder10 <= 4
                ? 'смены'
                : 'смен'
    return `${count} ${word}`
}

function formatError(error: CopyError) {
    const employeeName = error.details?.employee_name
    const message = error.message || 'Не удалось выполнить копирование смен'
    return typeof employeeName === 'string' ? `${employeeName}: ${message}` : message
}
</script>
